module.exports = __webpack_public_path__ + "img/program-radio.85a684cf.jpg";